import { render } from "./CreatePharmacy.vue?vue&type=template&id=c9ecef18&scoped=true"
import script from "./CreatePharmacy.vue?vue&type=script&lang=js"
export * from "./CreatePharmacy.vue?vue&type=script&lang=js"

import "./CreatePharmacy.vue?vue&type=style&index=0&id=c9ecef18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9ecef18"]])

export default __exports__